import {
  rcoCrossBorderShipmentSegmentSchema,
  RcoSegmentStep,
} from "@redotech/redo-flows-common/advanced-flow-db-parser";
import { useTranslation } from "@redotech/redo-i18n";
import { Flex } from "@redotech/redo-web/flex";
import { Text } from "@redotech/redo-web/text";
import { memo } from "react";

export const CrossBorderShipmentInspectorContent = memo(
  function CrossBorderShipmentInspectorContent({
    step,
  }: {
    step: RcoSegmentStep;
  }) {
    const { t } = useTranslation();
    rcoCrossBorderShipmentSegmentSchema.parse(step.segment);

    return (
      <Flex align="flex-start" dir="column" gap="xs">
        <Text fontSize="xs" fontWeight="medium" textColor="secondary">
          {t("Condition")}
        </Text>
        <Text fontSize="xs" fontWeight="medium" textColor="primary">
          {t("Origin country differs from destination country")}
        </Text>
      </Flex>
    );
  },
);

export const EditableCrossBorderShipmentInspectorContent = memo(
  function EditableCrossBorderShipmentInspectorContent({
    step,
  }: {
    step: Omit<RcoSegmentStep, "matchingNextId" | "nonMatchingNextId"> & {
      matchingNextId?: string | undefined;
      nonMatchingNextId?: string | undefined;
    };
  }) {
    const { t } = useTranslation();
    rcoCrossBorderShipmentSegmentSchema.parse(step.segment);

    return (
      <Flex align="flex-start" dir="column" gap="xs">
        <Text fontSize="xs" fontWeight="medium" textColor="secondary">
          {t("Condition")}
        </Text>
        <Text fontSize="xs" fontWeight="medium" textColor="primary">
          {t("Origin country differs from destination country")}
        </Text>
      </Flex>
    );
  },
);
